import docStateSlice from '@/pages/doc/stores/doc-store';
import { configureStore, createSlice } from '@reduxjs/toolkit';
import localesStateSlice from '../locale/store';
import searchStateSlice from '../search/store';
const store = configureStore({
    reducer: {
        home: createSlice({
            name: 'home',
            initialState: {},
            reducers: {
                setTitle(state) {
                }
            }
        }).reducer,
        doc: docStateSlice,
        search: searchStateSlice,
        locales: localesStateSlice,

    }
});

export type RootState = ReturnType<typeof store.getState>;

export default store;
